import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import StatsSection from './components/StatsSection';
import ProcessSection from './components/ProcessSection';
import LocationSection from './components/LocationSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  return (
    <>
      <head>
        <title>Black Dog Settlement | Title &amp; Settlement Services Bucks Montgomery Chester Delaware County PA</title>
        <meta name="description" content="Black Dog Settlement provides professional title insurance, residential settlements, commercial closings, and title searches in Bucks, Montgomery, Chester, and Delaware County, PA. Call 215-499-0796." />
        <meta name="keywords" content="title settlement Bucks County PA, settlement company Newtown PA, title insurance Montgomery County, real estate closing Chester County Delaware County Pennsylvania" />
        <link rel="canonical" href="https://www.blackdogsettlement.com/" />
        <meta name="geo.region" content="US-PA" />
        <meta name="geo.placename" content="Newtown, Pennsylvania" />
        <meta name="geo.position" content="40.2290;-74.9340" />
        <meta property="og:title" content="Black Dog Settlement | PA Title &amp; Settlement Services" />
        <meta property="og:description" content="Trusted title and settlement services across Bucks, Montgomery, Chester, and Delaware Counties in Pennsylvania." />
        <meta property="og:type" content="website" />
        <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@600;700;800;900&family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Black Dog Settlement",
          "image": "https://www.blackdogsettlement.com/logo.png",
          "telephone": "+12154990796",
          "email": "info@blackdogsettlement.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "842 Durham Rd",
            "addressLocality": "Newtown",
            "addressRegion": "PA",
            "postalCode": "18940",
            "addressCountry": "US"
          },
          "areaServed": ["Bucks County", "Montgomery County", "Chester County", "Delaware County"],
          "openingHoursSpecification": [
            { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "09:00", "closes": "17:00" }
          ],
          "url": "https://www.blackdogsettlement.com"
        })}</script>
      </head>
      <main style={{ fontFamily: "'Inter', sans-serif" }}>
        <Navbar />
        <HeroSection />
        <StatsSection />
        <ServicesOverview />
        <ProcessSection />
        <LocationSection />
        <TestimonialsSection />
        <ContactSection />
        <Footer />
      </main>
    </>
  );
};

export default HomePage;
